import React from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services/AuthService';

const styles = {
  page: {
    minHeight: '100vh',
    background: '#0d1117',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  cardsRow: {
    display: 'flex',
    gap: '28px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  card: {
    width: 'min(260px, 80vw)',
    height: '200px',
    background: '#161b22',
    border: '1.5px solid #21262d',
    borderRadius: '18px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    cursor: 'pointer',
    transition: 'border-color 0.2s, transform 0.15s, background 0.2s',
    userSelect: 'none',
  },
  cardLabel: {
    color: '#e6edf3',
    fontSize: '17px',
    fontWeight: '600',
    letterSpacing: '0.2px',
  },
  logoutBtn: {
    position: 'fixed',
    top: '18px',
    right: '20px',
    background: 'none',
    border: '1px solid #30363d',
    color: '#8b949e',
    padding: '6px 14px',
    borderRadius: '6px',
    fontSize: '13px',
    cursor: 'pointer',
  },
};

// Cyan people icon (SVG) — matches Gatnix style
function InterviewIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* center person */}
      <circle cx="32" cy="22" r="8" fill="#00c8c8" />
      <path d="M18 50c0-7.732 6.268-14 14-14s14 6.268 14 14" stroke="#00c8c8" strokeWidth="3.5" strokeLinecap="round" fill="none"/>
      {/* left person */}
      <circle cx="14" cy="25" r="6" fill="#00c8c8" opacity="0.65"/>
      <path d="M4 50c0-5.523 4.477-10 10-10" stroke="#00c8c8" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.65"/>
      {/* right person */}
      <circle cx="50" cy="25" r="6" fill="#00c8c8" opacity="0.65"/>
      <path d="M60 50c0-5.523-4.477-10-10-10" stroke="#00c8c8" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.65"/>
    </svg>
  );
}

// Cyan chat bubble icon
function ChatIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 12h44a4 4 0 0 1 4 4v26a4 4 0 0 1-4 4H20l-12 8V16a4 4 0 0 1 4-4z"
        stroke="#00c8c8"
        strokeWidth="3.5"
        strokeLinejoin="round"
        fill="none"
      />
      {/* dots */}
      <circle cx="24" cy="27" r="3" fill="#00c8c8"/>
      <circle cx="32" cy="27" r="3" fill="#00c8c8"/>
      <circle cx="40" cy="27" r="3" fill="#00c8c8"/>
    </svg>
  );
}

export default function Dashboard() {
  const navigate = useNavigate();

  const handleCardHover = (e, hovered) => {
    e.currentTarget.style.borderColor   = hovered ? '#00c8c8' : '#21262d';
    e.currentTarget.style.transform     = hovered ? 'translateY(-4px)' : 'translateY(0)';
    e.currentTarget.style.background    = hovered ? '#1a2332' : '#161b22';
  };

  return (
    <div style={styles.page}>
      <button
        style={styles.logoutBtn}
        onClick={() => { logout(); navigate('/'); }}
        onMouseEnter={e => e.currentTarget.style.color = '#e6edf3'}
        onMouseLeave={e => e.currentTarget.style.color = '#8b949e'}
      >
        Logout
      </button>

      <div style={styles.cardsRow}>
        {/* Start Interview */}
        <div
          style={styles.card}
          onClick={() => navigate('/settings')}
          onMouseEnter={e => handleCardHover(e, true)}
          onMouseLeave={e => handleCardHover(e, false)}
        >
          <InterviewIcon />
          <span style={styles.cardLabel}>Start Interview</span>
        </div>

        {/* General Chat */}
        <div
          style={styles.card}
          onClick={() => navigate('/general-chat')}
          onMouseEnter={e => handleCardHover(e, true)}
          onMouseLeave={e => handleCardHover(e, false)}
        >
          <ChatIcon />
          <span style={styles.cardLabel}>General Chat</span>
        </div>
      </div>
    </div>
  );
}
